import { ModuleCodes } from '../../../../models/modules';
import { WebSocketsReservationEvents, WebSocketsTripEvents } from '../../../../models/web-sockets';

const mServerTable = {
  footer: {
    selectAll: 'בחר הכל',
    allPageSelected: {
      text: 'כל {{number}} הפריטים בדף זה נבחרו.',
      action: 'בחר את כל {{number}} הפריטים',
    },
    allPagesSelected: {
      text: 'כל {{number}} הפריטים בטבלה נבחרו.',
      action: 'נקה בחירה',
    },
  },
  noResults: 'אין תוצאות',
  total: 'סה"כ',
  generalSearch: 'חיפוש',
  actions: {
    more: 'עוד',
    clearFilters: 'נקה מסננים',
    hiddenColumns: 'עמודות מוסתרות',
    refreshTable: 'רענן טבלה',
  },
  floatingActions: {
    extraActionsMenu: {
      button: 'עוד',
      title: 'עוד פעולות',
    },
    selectedText: {
      single: 'פריט נבחר',
      many: 'פריטים נבחרו',
    },
  },
  updates: {
    [ModuleCodes.Trips]: {
      [WebSocketsTripEvents.New]: 'חדש',
      [WebSocketsTripEvents.Update]: 'עדכן',
      [WebSocketsTripEvents.Cancel]: 'ביטול',
      [WebSocketsTripEvents.StatusChange]: 'שינוי סטטוס',
    },
    [ModuleCodes.Reservations]: {
      [WebSocketsReservationEvents.New]: 'חדש',
      [WebSocketsReservationEvents.Update]: 'עדכן',
      [WebSocketsReservationEvents.Cancel]: 'ביטול',
      [WebSocketsReservationEvents.StatusChange]: 'שינוי סטטוס',
    },
  },
};

export default mServerTable;
